export default __webpack_public_path__ + "static/heading-image-fac1b2338022fea0f6a8b4a98f86f888.svg";